import { render, staticRenderFns } from "./BurstObservationList.vue?vue&type=template&id=32d5c806&"
import script from "./BurstObservationList.vue?vue&type=script&lang=ts&"
export * from "./BurstObservationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports